import React from 'react';
import PropTypes from 'prop-types';
import { BdsGrid, BdsIcon, BdsTooltip, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { InfoPaperHeader, InfoPaperBody, InfoPaperContainer, InfoPaperTitle } from './styles';

const InfoPaperComponent = ({
  icon = '',
  title,
  justifyContent = '',
  classNameTitle = '',
  text,
  tooltipIcon = '',
  tooltipText = '',
  tooltipVariation = '',
  bdsPaper = true,
  infoPaperType = 'number',
  tooltipTrackEvent,
  hasCentralized = false,
}) => {
  const showIcon = (icon && title.length <= 7 && infoPaperType === 'number') || infoPaperType === 'weekly';
  const variation = tooltipVariation || 'top-center';

  return (
    <InfoPaperContainer bdsPaper={bdsPaper} hasCentralized={hasCentralized}>
      <InfoPaperHeader justifyContent={justifyContent} showIcon={showIcon}>
        <BdsGrid justifyContent={'center'} alignItems='center'>
          {showIcon && <BdsIcon name={icon} size="medium"></BdsIcon>}
          <InfoPaperTitle className={classNameTitle}>
            <BdsTypo
              tag="span"
              variant={infoPaperType === 'weekly' ? 'fs-14' : 'fs-18'}
              bold={infoPaperType === 'weekly' ? 'bold' : 'extra-bold'}
              lineHeight="double"
            >
              {title}
            </BdsTypo>
          </InfoPaperTitle>
        </BdsGrid>
        {tooltipIcon && tooltipText && (
          <BdsTooltip position={variation} tooltip-text={tooltipText} onMouseOver={tooltipTrackEvent}>
            <BdsIcon name={tooltipIcon} size="x-small"></BdsIcon>
          </BdsTooltip>
        )}
      </InfoPaperHeader>
      <InfoPaperBody>
        <BdsTypo variant="fs-12" bold="semi-bold" lineHeight="plus">
          {text}
        </BdsTypo>
      </InfoPaperBody>
    </InfoPaperContainer>
  );
};

InfoPaperComponent.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  text: PropTypes.string.isRequired,
  tooltipIcon: PropTypes.string,
  tooltipText: PropTypes.string,
  tooltipVariation: PropTypes.string,
  bdsPaper: PropTypes.bool,
  infoPaperType: PropTypes.string,
  tooltipTrackEvent: PropTypes.func,
  hasCentralized: PropTypes.bool,
};

export { InfoPaperComponent };